import * as types from "../mutation-types";
import services from "services/events";
import _ from "lodash";

const state = {
  events: [],
  currentEvents: [],
  eventCategories: [],
  selectedEvent: {},
  filter: "all",
  pagination: [],
  totalPages: "",
  currentPage: "",
  currentEvent: {
    event: null,
    stand: null
  }
};

const getters = {
  getEvents(state) {
    return state.events;
  },
  getCurrentEvents(state) {
    return state.currentEvents;
  },
  getEventCategories(state) {
    return state.eventCategories;
  },
  getTotalPages(state) {
    return state.totalPages;
  },
  getCurrentPage(state) {
    return state.currentPage;
  },
  getPagination(state) {
    const { total, limit, skip } = state.pagination;
    return _.extend(state.pagination, {
      pages: Math.ceil(total / limit),
      current: Math.ceil((skip - 1) / limit) + 1
    });
  },
  selectEvent(state) {
    return state.selectedEvent;
  },
  getCurrentEvent: state => state.currentEvent
};

const mutations = {
  [types.FETCH_EVENTS](state, payload) {
    state.events = payload.events;
    state.pagination = payload.meta.pagination;
    state.totalPages = state.pagination.total_pages;
    state.currentPage = state.pagination.current_page;
  },

  [types.FETCH_CURRENT_EVENTS](state, payload) {
    state.currentEvents = payload;
  },

  [types.FETCH_EVENT_CATEGORIES](state, payload) {
    state.eventCategories = payload;
  },

  [types.ADD_EVENT](state, payload) {
    state.events.unshift(payload);
    state.pagination.total++;
  },

  [types.UPDATE_EVENT](state, payload) {
    // find the index of the obj to remove from array
    const index = _.findIndex(state.events, { id: payload.id });
    // Replace element at index
    state.events.splice(index, 1, event);
  },

  [types.REMOVE_EVENT](state, payload) {
    // find the index of the obj to remove from array
    const index = _.findIndex(state.events, { _id: payload._id });
    // remove the obj at position [index] from array
    state.events.$remove(state.events[index]);
  },

  [types.SELECT_EVENT](state, payload) {
    state.selectedEvent = payload;
  },

  [types.SELECT_CURRENT_EVENT](state, payload) {
    state.currentEvent = payload;
  }
};

const actions = {
  async fetchEvents({ commit }, query) {
    const payload = (await services.events(query)).data;
    commit(types.FETCH_EVENTS, await payload);
  },
  async fetchEventsList({ commit }, query) {
    const payload = (await services.eventsList(query)).data;
    commit(types.FETCH_EVENTS, await payload);
  },
  async fetchCurrentEvents({ commit }, query) {
    const payload = (await services.currentEvents(query)).data;
    commit(types.FETCH_CURRENT_EVENTS, await payload);
  },
  async fetchEventCategories({ commit }, query) {
    const payload = (await services.eventCategories(query)).data;
    commit(types.FETCH_EVENT_CATEGORIES, await payload);
  },
  async addEvent({ commit }, data) {
    const payload = (await services.addEvent(data)).data;
    commit(types.ADD_EVENT, await payload);
    commit(types.SELECT_EVENT, await payload);
  },
  resetEvent({ commit }) {
    commit(types.SELECT_EVENT, {});
  },
  selectCurrentEvent({ commit }, event) {
    commit(types.SELECT_CURRENT_EVENT, event);
  },
  async selectEvent({ commit }, id) {
    const payload = (await services.event(id)).data;
    commit(types.SELECT_EVENT, await payload);
  },
  async editEvent({ commit }, data) {
    const payload = (await services.editEvent(data)).data;
    commit(types.UPDATE_EVENT, data);
    commit(types.SELECT_EVENT, await payload);
  },
  async extendEventEnd({ commit }, data) {
    const payload = (await services.extendEventEnd(data)).data;
    commit(types.UPDATE_EVENT, data);
    commit(types.SELECT_EVENT, await payload);
  },
  updatedEvent: ({ commit }, data) => {
    commit(types.UPDATE_EVENT, data);
  },
  async removeEvent({ commit }, data) {
    const payload = (await services.deleteEvent(data)).data;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
